import React from "react";

const EditPoemPage = () => {
  return <div>EditPoemPage</div>;
};

export default EditPoemPage;
